import React, { useCallback } from 'react'
import { useModal, useModalExtra } from '../../../../_components/Modal'

/**
 * キャンセル確認モーダルを開くフック
 *
 * @param {Object} options
 * @param {function(): void} options.onDiscard 破棄して戻るボタン押下時の処理
 * @param {function(): void} options.onSave 保存して戻るボタン押下時の処理
 * @returns {function(): void} モーダルを開く関数
 */
export const useCancelConfirmModal = ({ onDiscard, onSave }) => {
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()

  const openCancelConfirmModal = useCallback(() => {
    showModal({
      title: '未保存の変更があります',
      description: (
        <div className="text-body text-caption-2 grey--text text-center">
          レポートデータ更新画面に戻る前に、変更を保存しますか？
        </div>
      ),
      isCancel: false,
      isWide: false,
      isSpinnerDisabled: false,
      modalClass: 'modal-window--file-mgmt-cancel-confirm',
      footerButtonAreaClass: 'gap-x-8',
      button: [
        {
          name: 'キャンセル',
          className: 'btn footer-btn button_back px-6 whitespace-nowrap',
          click: () => {}
        },
        {
          name: '破棄して戻る',
          className: 'btn footer-btn button_back px-6 whitespace-nowrap',
          click: onDiscard
        },
        {
          name: '保存して戻る',
          className: 'btn footer-btn button_base px-6 whitespace-nowrap',
          click: async () => {
            await onSave()
            _closeUpModal()
          },
          close: false
        }
      ]
    })
  }, [showModal, onDiscard, onSave, _closeUpModal])

  return openCancelConfirmModal
}
